import { render, staticRenderFns } from "./LiveStream.vue?vue&type=template&id=2555f9a0&scoped=true"
import script from "./LiveStream.vue?vue&type=script&lang=js"
export * from "./LiveStream.vue?vue&type=script&lang=js"
import style0 from "./LiveStream.vue?vue&type=style&index=0&id=2555f9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2555f9a0",
  null
  
)

export default component.exports